import { projectTitle } from "../../constants";
export const navigationBreadcrumbs = [
  {
    text: projectTitle,
    href: '/',
  },
  {
    text: 'Navigation',
    href: '/',
  },
];

export const uploadFilesBreadcrumbs = [
  ...navigationBreadcrumbs,
  {
    text: 'Upload File(s)',
    href: '/uploadfiles',
  },
];

export const statsBreadcrumbs = [
  ...navigationBreadcrumbs,
  {
    text: 'Stats',
    href: '/stats',
  },
];

